import { skills } from '../data/skills';

export default function Skills() {
  const skillSections = [
    {
      key: 'languages',
      title: 'Languages',
      iconPath:
        'M8 3C6.9 3 6 3.9 6 5V9C6 10.1 6.9 11 8 11H11V14H8C6.9 14 6 14.9 6 16V20C6 21.1 6.9 22 8 22H16C17.1 22 18 21.1 18 20V16C18 14.9 17.1 14 16 14H13V11H16C17.1 11 18 10.1 18 9V5C18 3.9 17.1 3 16 3H8M8 5H16V9H8V5M8 16H16V20H8V16Z'
    },
    {
      key: 'frameworks',
      title: 'Frameworks',
      iconPath:
        'M19 3H5C3.89 3 3 3.89 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.89 20.1 3 19 3M19 19H5V5H19V19M17 17H7V13H17V17M17 11H7V7H17V11Z'
    },
    {
      key: 'tools',
      title: 'Tools',
      iconPath:
        'M22.7 19L13.6 9.9C14.5 7.6 14 4.9 12.1 3C10 0.9 6.8 0.5 4.3 1.7L8 5.4L5.4 8L1.7 4.3C0.5 6.8 0.9 10 3 12.1C4.9 14 7.6 14.5 9.9 13.6L19 22.7C19.4 23.1 20 23.1 20.4 22.7L22.7 20.4C23.1 20 23.1 19.4 22.7 19Z'
    },
    {
      key: 'technologies',
      title: 'Technologies & Libraries',
      iconPath:
        'M12,2L13.09,8.26L22,9L13.09,9.74L12,16L10.91,9.74L2,9L10.91,8.26L12,2M12,21.5C16.14,21.5 19.5,18.14 19.5,14H16.5C16.5,16.5 14.5,18.5 12,18.5C9.5,18.5 7.5,16.5 7.5,14H4.5C4.5,18.14 7.86,21.5 12,21.5Z'
    },
    {
      key: 'MachineLearning',
      title: 'Machine Learning',
      iconPath:
        'M12 2A10 10 0 0 0 2 12C2 15.9 4.2 19.3 7.5 21V14.5H5V12H7.5V10C7.5 7.5 9 6 11.3 6C12.4 6 13.5 6.2 13.5 6.2V8.6H12.2C10.9 8.6 10.5 9.4 10.5 10.3V12H13.4L12.9 14.5H10.5V21C19.8 19.3 22.8 7.3 15.3 3.1C14.3 2.4 13.2 2 12 2Z'
    }
  ];

  return (
    <section id="skills" className="skills-section">
      <div className="skills-container fade-in-visible">
        <div className="skills-main-title">
          <span className="text-content">Skills</span>
        </div>
        <div className="skills-content">
          {skillSections.map((section) => (
            <div
              key={section.key}
              className={`skills-column ${section.key === 'MachineLearning' ? 'skills-column-wide' : ''}`}
            >
              <div className="skills-header">
                <svg className="skills-icon" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d={section.iconPath} />
                </svg>
                <h3 className="skills-title">{section.title}</h3>
              </div>
              <div className="skills-grid">
                {(skills[section.key] || []).map((skill, index) => (
                  <div key={`${section.key}-${index}`} className="skill-tag">
                    {skill}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}